@if (!clickable()) {
  <span class="rounded px-2 py-0.5 text-xs" [ngClass]="badgeClasses()">
    {{ typeLabel() }}
  </span>
} @else {
  <button
    [matMenuTriggerFor]="typeMenu"
    class="shrink-0 cursor-pointer rounded px-2 py-0.5 text-xs transition-all hover:ring-2 hover:ring-gray-300"
    [ngClass]="badgeClasses()"
  >
    {{ typeLabel() }}
  </button>
  <mat-menu #typeMenu="matMenu" class="no-width-constraints">
    @if (typeInfo(); as info) {
      <div class="w-64 p-3" (click)="$event.stopPropagation()">
        <div class="mb-2 flex items-center gap-2">
          <span
            class="rounded px-1.5 py-0.5 text-xs font-medium"
            [ngClass]="inactive() ? { 'bg-gray-100': true, 'text-gray-400': true } : badgeClasses()"
          >
            {{ typeLabel() }}
          </span>
          <span class="font-semibold text-gray-900">{{ info.name }}</span>
        </div>
        <p class="mb-3 text-sm text-gray-600">{{ info.description }}</p>
        <div class="border-t border-gray-100 pt-2">
          <div class="mb-1 text-xs font-medium text-gray-500">Examples</div>
          <div class="rounded bg-gray-50 px-2 py-1.5 text-sm">
            <markdown [data]="info.example" [katex]="true" [katexOptions]="katexOptions"></markdown>
          </div>
        </div>
        @if (info.representationId) {
          <div class="mt-2 border-t border-gray-100 pt-2">
            <div class="flex items-center justify-between text-xs">
              <span class="text-gray-500">Representation ID</span>
              <code class="rounded bg-gray-100 px-1.5 py-0.5 text-gray-600">{{ info.representationId }}</code>
            </div>
          </div>
        }
      </div>
    }
  </mat-menu>
}
